// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { NavigationItem } from "./CommonHeader.config";

export type UpdateSelectedNavItemSignature = (selectedNavItem: NavigationItem, isContextualSecondaryNavEnabled?: boolean) => void;
export type UpdateSelectedTwoLevelNavItemSignature = (selectedNavMenuItem: NavigationItem, selectedNavItem: NavigationItem, selectedSecondaryNavMenuItem: NavigationItem, selectedSecondaryNavItem: NavigationItem) => void;
export type UpdateIsTtvrFiredSignature = (isTtvrFired: boolean) => void;

/**
 * Class containing actions that apply to the CommonHeader connector
 */
export class CommonHeaderActions {
    public static updateSelectedNavItem = new ActionMap<UpdateSelectedNavItemSignature>("UpdateSelectedNavItem");
    public static updateSelectedTwoLevelNavItems = new ActionMap<UpdateSelectedTwoLevelNavItemSignature>("UpdateSelectedTwoLevelNavItems");
    public static updateIsTtvrFired = new ActionMap<UpdateIsTtvrFiredSignature>("UpdateIsTtvrFired");
}